import React from 'react'
import PropTypes from 'prop-types'

import './GallerySlide.css'

const GallerySlide = ({ url, imageSource }) => (
    <a href={url} className="gallery-slide" target="_blank" rel="noopener noreferrer">
        <div className="gallery-slide__image" style={{ backgroundImage: `url("${url}")` }}>
            <div className="gallery-slide__image__source">{imageSource}</div>
        </div>
    </a>
)

GallerySlide.propTypes = {
    url: PropTypes.string.isRequired,
    imageSource: PropTypes.string
}

export { GallerySlide }
